import { Injectable } from '@angular/core';

import { AlertService } from './alert.service';
import { AuthenticationService } from './authentication.service';
import { CollaboratoreService } from './collaboratore.service';
import { ImmobiliareService } from './immobiliare.service';
import { PagerService } from './pager.service';
import { ProfiloService } from './profilo.service';
import { TrascodificaService } from './trascodifica.service';
import { ServizioImmobileService } from './servizio-immobile.service';
import { ServizioAcquirenteService } from './servizio-acquirente.service';
import { ComuneService } from './comune.service';
import { FileService } from './file.service';
import { MessaggioService } from './messaggio.service';
import { CartService } from './cart.service';
import { ProvinciaService } from './provincia.service';
import { CapService } from './cap.service';
import { EmailTemplateService } from './email-template.service';
import { BloccoImmobileService } from './blocco-immobile.service';
import { PagamentoService } from './pagamento.service';
import { OrarioService } from './orario.service';
import { ImpostazioniService } from './impostazioni.service'
import { BackOfficeService } from './back-office.service';
import { AnagraficaService } from './anagrafica.service';
import { ResetPasswordService } from './reset-password.service';
import { TokenExpiredService } from './token-expired.service';
import { RichiestaMutuoService } from './richiesta-mutuo.service';

@Injectable()
export class MainService {

	constructor(public alertService: AlertService,
		public authService: AuthenticationService,
		public collaboratoreService: CollaboratoreService,
		public immobiliareService: ImmobiliareService,
		public pagerService: PagerService,
		public profiloService: ProfiloService,
		public trascodifica: TrascodificaService,
		public servizioImmobileService: ServizioImmobileService,
		public servizioAcquirente: ServizioAcquirenteService,
		public comuneService: ComuneService,
		public provinciaService: ProvinciaService,
		public capService: CapService,
		public fileService: FileService,
		public messaggioService: MessaggioService,
		public cartService: CartService,
		public emailTemplateService: EmailTemplateService,
		public bloccoImmobileService: BloccoImmobileService,
		public pagamentoService: PagamentoService,
		public orario: OrarioService,
		public impostazioniService: ImpostazioniService,
		public backOfficeService: BackOfficeService,
		public anagraficaService: AnagraficaService,
		public resetPassService: ResetPasswordService,
		public tokenExpiredService: TokenExpiredService,
		public richiestaMutuoService: RichiestaMutuoService
	) { }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/main.service.ts